<template>
  <div class="row">
    <div
      v-for="rc in complexes"
      :key="`${locale.value}-${rc.id}`"
      class="col-md-4 mb-4"
    >
      <div class="single-property-card card h-100 border-0 shadow-sm">
        <RouterLink
          :to="`/public/developers/${rc.developer_id}/residential_complexes/${rc.id}`"
          class="text-decoration-none"
        >
          <div class="property-image-wrapper">
            <img
              :src="rc.cover_image_url || '/images/default-cover.jpg'"
              :alt="t('residential_complex.complex.gallery')"
              class="card-img-top"
              style="height: 300px; object-fit: cover;"
            />
          </div>

          <div class="card-body">
            <h5 class="card-title mb-1">{{ rc.name }}</h5>
            <p class="text-muted small mb-2">
              🌍 {{ rc.country_name || '—' }},
              🗺️ {{ rc.region_name || '—' }},
              🏙 {{ rc.city_name || '—' }}
              <span v-if="rc.district_name">, 🏘 {{ rc.district_name }}</span>
            </p>

            <p class="small mb-1">
              🏷️ {{ t('residential_complex.residential_class.complex.class') }}:
              {{ rc.residential_class || t('common.not_available') }}
            </p>

            <ul class="list-unstyled small mb-2">
              <li v-if="rc.construction_start_date">🧱 {{ t('residential_complex.complex.construction_start') }}: {{ formatDate(rc.construction_start_date) }}</li>
              <li v-if="rc.sales_start_date">🛒 {{ t('residential_complex.complex.sales_start') }}: {{ formatDate(rc.sales_start_date) }}</li>
              <li v-if="rc.construction_end_date">🏗 {{ t('residential_complex.complex.construction_end') }}: {{ formatDate(rc.construction_end_date) }}</li>
              <li v-if="rc.expected_delivery_date">📦 {{ t('residential_complex.complex.expected_delivery') }}: {{ formatDate(rc.expected_delivery_date) }}</li>
            </ul>

            <div class="d-flex justify-content-between small mb-2">
              <span>{{ t('residential_complex.complex.total') }}: {{ rc.total_units || 0 }}</span>
              <span>{{ t('residential_complex.complex.available') }}: {{ rc.available_units || 0 }}</span>
            </div>

            <div v-if="rc.buildings_info?.length" class="small text-muted">
              <span class="fw-semibold">🏢 {{ t('residential_complex.complex.buildings') }}:</span>
              <ul class="ps-3 mb-0">
                <li v-for="b in rc.buildings_info" :key="b.id">
                  {{ b.name }} ({{ b.total_floors || 0 }} {{ t('residential_complex.complex.floors_short') }})
                </li>
              </ul>
            </div>
          </div>
        </RouterLink>
      </div>
    </div>
  </div>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const props = defineProps({
  complexes: { type: Array, required: true }
})

const { t, locale } = useI18n()

const formatDate = (dateStr) => {
  if (!dateStr) return ''
  const date = new Date(dateStr)
  if (isNaN(date)) return dateStr
  return new Intl.DateTimeFormat(locale.value, {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric'
  }).format(date)
}
</script>

<style scoped>
.single-property-card {
  transition: all 0.2s ease;
}
.single-property-card:hover {
  transform: translateY(-2px);
}
</style>
